import * as React from 'react';
import { SelectList } from '../SelectList';
import { WizardActions } from '../../Shared/Styled';
import { WizardButton } from '../../Shared/Wizard';
import { useThemeContext } from '../../../context';
import {
  centeredFull,
  defaultFont,
  themedText,
} from '../../../styles/SharedStyles';
import { PwWebConection, SelectItem } from '../../../types';
import { ConnectionDefaultTabToggle } from './ConnectionDefaultTabToggle';
import { User } from 'oidc-client';

export interface ConnectionSelectionProps {
  mappedConnections: SelectItem[];
  connection?: PwWebConection;
  label: string;
  tabIsDefault: boolean;
  tabConfigured: boolean;
  user?: User;
  setTabIsDefault: (value: boolean) => any;
}

export function ConnectionSelection({
  mappedConnections,
  connection,
  label,
  tabIsDefault,
  tabConfigured,
  user,
  setTabIsDefault,
}: ConnectionSelectionProps): JSX.Element {
  const theme = useThemeContext();

  return (
    <div
      id='ConnectionSelection'
      style={{
        display: 'inline-flex',
        width: '100%',
        flexDirection: 'column',
      }}
    >
      {mappedConnections.length ? (
        <>
          <SelectList
            items={mappedConnections}
            label={label}
            selected={connection?.name}
          />
          <ConnectionDefaultTabToggle
            tabIsDefault={tabIsDefault}
            setTabIsDefault={setTabIsDefault}
            user={user}
            isPw365Project={false}
            connection={connection}
          />
        </>
      ) : (
        <p style={{ ...centeredFull, ...defaultFont, ...themedText(theme) }}>
          This project does not have any ProjectWise connections.
        </p>
      )}
      <WizardActions>
        <WizardButton direction='back' label='Project' theme={theme} />
        {!tabConfigured && (
          <WizardButton
            direction='forward'
            label='Tab Name'
            disabled={!connection?.name}
            theme={theme}
          />
        )}
      </WizardActions>
    </div>
  );
}
